import axios from 'axios';

// setup_token is provided during forced login setup; omit it for the jwt-cookie flow.
async function setupInit(setup_token) {
    const body = setup_token ? { setup_token } : {};
    const response = await axios.post('admin/2fa/setup/init', body, { withCredentials: true });
    return response?.data;
}

// setup_token is provided during forced login setup; omit it for the jwt-cookie flow.
async function setupConfirm(totp_code, setup_token) {
    const body = setup_token ? { setup_token, totp_code } : { totp_code };
    const response = await axios.post('admin/2fa/setup/confirm', body, { withCredentials: true });
    return response?.data;
}

export default {
    setupInit,
    setupConfirm,
};
